import { Component, OnInit } from '@angular/core';
import { LoginService } from '../security/login.service';
import { ApiErrorService } from '../api-error.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-api-exception',
  templateUrl: './error-api-exception.component.html',
  styleUrls: ['./error-api-exception.component.css']
})
export class ErrorApiExceptionComponent implements OnInit {

  errorStatus!: number;
  errorMessage!: string;

  constructor(
    private loginService: LoginService,
    private apiErrorService: ApiErrorService,
    private router: Router
  ) {
    this.loginService.activatedNavigationComponent = false;
    if(this.apiErrorService.error){
      this.errorStatus = this.apiErrorService.error.httpStatus;
      this.errorMessage = this.apiErrorService.error.message;
    } else {
      window.location.href = "https://languesvivantes.com";
    }

   }

  ngOnInit(): void {
  }

}
